import ApiRequestManagerInstance from '../ApiRequestManager';
import Content from '../../types/enums/content';
import Rail from '../../classes/rail';
import TranslationManager from '../../assets/locale/translationsManager';
import { IAddonsRequest } from '../../types/interfaces/rail';
import { RailDisplayMode } from '../../types/enums/rail';
import { store } from '../../store/store';

function addonRailRequest() {
  const promise = new Promise<Rail | null>(async (resolve) => {
    try {
      const { user } = store.getState();
      if (user.isAnonymous) {
        resolve(null);
        return;
      }
      const response: IAddonsRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'apiUrl',
          section: 'user',
          subsection: 'addons',
          version: 'v1',
        },
      })) as IAddonsRequest;
      const addons = response.data.addons.map((item) => {
        const newData = {
          ...item,
          kind: Content.ADDON,
          tick: false,
        };
        return newData;
      });
      if (!addons.length) {
        resolve(null);
        return;
      }
      const addonRail = {
        kind: Content.ADDON,
        reloadable: true,
        section: {
          title: TranslationManager.get('COMPONENTS.RAILS.TITLE.ADDONS'),
          presentationType: RailDisplayMode.PHOTO,
          name: 'addon',
        },
        shows: { data: addons },
      };
      resolve(new Rail(addonRail));
    } catch (e) {
      resolve(null);
    }
  });

  return promise;
}

export default addonRailRequest;
